import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'

function RefundPolicy() {


     const [pageTitle,setPageTitle] = useState('About Us');
                        const [pageContent,setPageContent] = useState('');
                    useEffect(() => {
                            getData()
                        }, []);
                        const getData = async () => {
                            try {
                                const response = await fetch('https://api.kahaaniplus.com/api/v1/page/refund-cancellation-policy');
                                const data = await response.json();
                                setPageTitle(data.data.page_title);
                                setPageContent(data.data.page_content);
                                console.log(data);
                            } catch (error) {
                                console.error('Error fetching data:', error);
                            }
                        };
    
    


    return (
        <Container className='mt-5'>
            <h1 className='text-center'>{pageTitle}</h1>
            <p className='my-para'  dangerouslySetInnerHTML={{ __html: pageContent }}>
              {/*   To the maximum extent permitted under applicable law, the Subscription Fees billed are non-refundable irrespective of whether the Service have been availed by You or not, and there shall be no refunds or credits for partially used periods and/or unwatched content. Your subscription plan will continue to remain active till the end of the Subscription Term, irrespective of when You cancel the Service. Any request for change or cancellation in any Subscription Plan prior to the expiration of the current Subscription Term period will not entail You to a refund for any portion of the Subscription Fee paid by You for the unexpired period of the current Subscription Term. Any changes in the subscription plan opted by You is effective only after the expiry of the current Subscription Term for which You have already been billed. Accordingly, the Service as per revised plan opted by You shall be effective only after the expiry of the then current Subscription Term, subject to You making all necessary payments.
                Return & Shipping Policy:
                As a provider of digital services and products, we do not have a return or shipping policy in the traditional sense, as we do not deal with physical goods. Due to the nature of our digital services and products, we do not accept returns, or exchanges & no shipping is involved. Our services are accessible through our platform, and any associated content can be accessed online once you are subscribed.
 */}
            </p>
        </Container>
    )
}

export default RefundPolicy